import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import { selectUser } from './storeSelectors/user.js';
import './index-QrdBfapu.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import { L as LOGIN } from './paths-ZKN3m62_.js';
import './payment-5CMab_Gs.js';
import useAutoFocus from './hooks/useAutoFocus.js';
import './index-vPolXUOt.js';
import 'notistack';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-qyZpLI0y.js';
import 'lodash';
import './utils/currency.js';
import { formatPoints } from './utils/price.js';
import 'next/server';
import './index-Oip0gjfj.js';
import './graphqlRequestClient-7kdUKc_c.js';
import { a as ACCOUNT_MENU_ITEMS } from './account-o8FpsAAZ.js';
import { AccorAuthContext, loginWithAccor, signUpWithAccor } from './context/auth/index.js';
import Link from './components/Link/index.js';

var ActionType;
(function (ActionType) {
    ActionType["Initial"] = "Initial";
    ActionType["Login"] = "Login";
    ActionType["Register"] = "Register";
    ActionType["ForgotPassword"] = "ForgotPassword";
    ActionType["Account"] = "Account";
})(ActionType || (ActionType = {}));

const MyAccount = ({ onLogout, isLogged, setActionType, onAccorLogout }) => {
    var _a, _b;
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { actions: { modal: { toggleModal, toggleShowMobileMenu }, }, data: { siteConfig: { siteName = '', enableAccorLoyaltyProgramme = false } = {} }, useDispatch, useSelector, } = useContext(CoreContext);
    const user = useSelector(selectUser);
    const accorAuthContext = enableAccorLoyaltyProgramme ? useContext(AccorAuthContext) : null;
    const isAccorLoggedIn = (_a = accorAuthContext === null || accorAuthContext === void 0 ? void 0 : accorAuthContext.isAccorLoggedIn) !== null && _a !== void 0 ? _a : false;
    const accorUser = (_b = accorAuthContext === null || accorAuthContext === void 0 ? void 0 : accorAuthContext.accorUser) !== null && _b !== void 0 ? _b : null;
    const { locale, route, push } = useRouter();
    const isAccountPage = route.includes('/account');
    const dispatch = useDispatch();
    const router = useRouter();
    const totalPoints = formatPoints(accorUser === null || accorUser === void 0 ? void 0 : accorUser.points, locale);
    const handleClose = () => {
        dispatch(toggleModal(null));
    };
    const handleAccorLogin = () => {
        loginWithAccor();
    };
    const handleAccorSignUp = () => {
        signUpWithAccor();
    };
    const logoutHandler = () => {
        handleClose();
        onLogout();
        if (isAccountPage) {
            router.replace(LOGIN);
        }
    };
    const goToPage = (url) => {
        push(`/${locale}${url}`);
        dispatch(toggleShowMobileMenu(false));
        handleClose();
    };
    const ref = useAutoFocus({ tag: 'button' });
    if (enableAccorLoyaltyProgramme) {
        return (React.createElement("div", { className: "loyalty-drawer" },
            isAccorLoggedIn ? (React.createElement("div", { className: "loyalty-block loyalty-block-empty" },
                React.createElement("h3", { className: "loyalty-title accor-logged-in" },
                    tHeading('loyaltyProgrammeAccount'),
                    ' ',
                    React.createElement("span", null,
                        "- ",
                        `${accorUser === null || accorUser === void 0 ? void 0 : accorUser.firstname} ${accorUser === null || accorUser === void 0 ? void 0 : accorUser.lastname}` || 'Member')),
                React.createElement("div", null,
                    React.createElement("p", { className: "loyalty-status-level" },
                        React.createElement("img", { src: "/images/misc/accor-a-logo.svg", alt: tLabel('$accor.accorRewards') }),
                        tLabel('status'),
                        " ",
                        React.createElement("span", null,
                            " ",
                            `${accorUser === null || accorUser === void 0 ? void 0 : accorUser.status_level}`)),
                    React.createElement("p", { className: "loyalty-points" },
                        tLabel('$accor.accorRewards'),
                        " : ",
                        React.createElement("span", null, `${totalPoints}`))),
                React.createElement(Link, { className: "loyalty-logout", onClick: onAccorLogout, black: true, noUnderline: true }, tButton('logOut')))) : (React.createElement("div", { className: "loyalty-block" },
                React.createElement("h3", { className: "loyalty-title" }, tHeading('loyaltyProgrammeAccount')),
                React.createElement("p", { className: "loyalty-text" }, tCommon('loyaltyProgrammeTip')),
                React.createElement("div", { className: "loyalty-actions" },
                    React.createElement("button", { type: "button", onClick: handleAccorLogin, className: "btn btn-main loyalty-btn" }, tButton('logIn')),
                    React.createElement("button", { type: "button", onClick: handleAccorSignUp, className: "btn btn-plain loyalty-btn" }, tButton('signUpForFree'))))),
            React.createElement("div", { className: "loyalty-or" },
                React.createElement("span", null, tCommon('or'))),
            isLogged ? (React.createElement("div", { className: "loyalty-block loyalty-block-empty" },
                React.createElement("h3", { className: "loyalty-title" },
                    tHeading('sitenameAccount', { siteName }),
                    " -",
                    ' ',
                    React.createElement("span", null,
                        " ",
                        `${user === null || user === void 0 ? void 0 : user.firstname} ${user === null || user === void 0 ? void 0 : user.lastname}`)),
                React.createElement("ul", { ref: ref, className: "loyalty-account-list" }, ACCOUNT_MENU_ITEMS.map(item => (React.createElement("li", { key: item.name, className: "loyalty-account-list-item" },
                    React.createElement(Link, { className: "drawer-option", onClick: () => goToPage(item.path), noUnderline: true }, tLabel(item.name)))))),
                React.createElement(Link, { className: "loyalty-logout", onClick: logoutHandler, black: true, noUnderline: true }, tButton('logOut')))) : (React.createElement("div", { className: "loyalty-block loyalty-block-empty" },
                React.createElement("h3", { className: "loyalty-title" }, tHeading('sitenameAccount', { siteName })),
                React.createElement("p", { className: "loyalty-text" }, tCommon('loginTip')),
                React.createElement("div", { className: "loyalty-actions" },
                    React.createElement("button", { type: "button", onClick: () => setActionType(ActionType.Login), className: "btn btn-main" }, tButton('logIn')),
                    React.createElement(Link, { href: `/${locale}/user/register`, className: "btn btn-plain", onClick: handleClose }, tButton('signUp'))))),
            React.createElement("p", { className: "loyalty-faq" },
                React.createElement("span", null,
                    tLabel('faqFooter'),
                    ": "),
                tCommon('doubleLogin'),
                React.createElement(Link, { onClick: handleClose, href: "/help/dual-account-logins" }, tButton('learnMore')))));
    }
    return (React.createElement("ul", { ref: ref, className: "account-list" },
        ACCOUNT_MENU_ITEMS.map(item => (React.createElement("li", { key: item.name },
            React.createElement(Link, { className: classnames('drawer-option uppercase', {
                    active: router.pathname === item.path,
                }), onClick: () => goToPage(item.path), noUnderline: true }, tLabel(item.name))))),
        React.createElement("li", null,
            React.createElement(Link, { className: "drawer-option uppercase", onClick: logoutHandler, black: true, noUnderline: true }, tButton('logOut')))));
};

export { ActionType as A, MyAccount as M };
//# sourceMappingURL=MyAccount-HuAGC722.js.map
